import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { keyframes } from "@emotion/core";
export var getMenuAnimationDirection = function getMenuAnimationDirection(placement) {
  switch (placement) {
    case "top-start":
    case "top":
    case "top-end":
      return "bottom";
    case "right-start":
    case "right":
    case "right-end":
      return "left";
    case "left-end":
    case "left":
    case "left-start":
      return "right";
    case "bottom-end":
    case "bottom":
    case "bottom-start":
    default:
      return "top";
  }
};

// only to be used with Ursa
export var getMenuAnimation = function getMenuAnimation(placement) {
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    from {\n        margin-", ": -8px;\n    } to {\n        margin-", ": 0px;\n    }\n"])), getMenuAnimationDirection(placement), getMenuAnimationDirection(placement));
};
//# sourceMappingURL=getMenuAnimation.js.map